module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog\"> <div class=\"modal-content\"> <div class=\"modal-header\"> <h4 class=\"modal-title\">Remove Payment Method</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> </div> <section class=\"modal-body\"> <p>Are you sure you want to remove this payment method?</p> </section> <section class=\"modal-footer\"> <button class=\"btn btn-clear cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-danger confirm_remove\" type=\"button\">Remove</button> </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/payment_method_remove_modal.ejs
// module id = 1249
// module chunks = 1